<table mat-table *ngIf="rowSpansMaterialsTable" [dataSource]="materialsTableDataSource"
  class="mat-elevation-z8 table-wide" id="components-table">
  <ng-container *ngFor="let column of dataColumnsMaterials; let iCol = index" [matColumnDef]="column.columnDef">
    <th mat-header-cell *matHeaderCellDef [class]="column.columnDef" class="header">
      {{ column.header }}
    </th>
    <td mat-cell *matCellDef="let row; let iRow = index" class="cell"
      [attr.rowspan]="rowSpansMaterialsTable[iCol][iRow].span"
      [style.display]="rowSpansMaterialsTable[iCol][iRow].span === 0 ? 'none'  : ''"
      [style.border-top]="rowSpansMaterialsTable[iCol][iRow].border">
      <div [ngSwitch]="column.columnDef">
        <ng-container *ngSwitchCase="'rating'">
          <div class="circle" [style.background]="column.color(row)" [style.color]="column.fontColor(row)"
            [matTooltip]="column.tooltip(row)">
            {{ column.cell(row) }}
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="'recyclingStream'">
          <div class="icon-text-container" *ngIf="column.cell(row)===''">
            {{ 'analysis.recyclabilityAnalysis.noInformation' | transloco }}
            <mat-icon class="gray-icon-18" [matTooltip]="column.recyclingStreamTooltip(row)">info
            </mat-icon>
          </div>
          {{ column.cell(row) }}
        </ng-container>
        <ng-container *ngSwitchDefault>
          {{ column.cell(row) }}
        </ng-container>
      </div>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumnsMaterials"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumnsMaterials"></tr>
</table>